<template>
  <div class="recommend-popup">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head text-center">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body text-center px-25 pt-30 pb-40">
        <div class="content" style="width: 398px;">
          <div v-if="itemTitleShow">{{ item.title }}</div>
          <div v-if="itemContentShow" class="description mt-15">{{ item.content }}</div>
          <div class="text-center mt-15">
            <div class="mb-15">
              <button :disabled="isConfirmed" class="button is-primary" type="button" @click="confirm()">
                <span>追加</span>
              </button>
            </div>
            <button class="button is-outlined" @click="close()">キャンセル</button>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<style lang="scss" src="./confirm-popup.scss" scoped>
</style>
<script>
export default {
  name: 'RecommendPopup',
  props: {
    title: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => ({
        title: '',
        content: ''
      })
    },
    confirmed: {
      type: Boolean,
      default: () => false
    },
    confirm: {
      type: Function,
      default: () => null
    }
  },
  data() {
    return {
      isConfirmed: false
    };
  },
  computed: {
    itemTitleShow: function() {
      return this.item && this.item.title && this.item.title.length > 0;
    },
    itemContentShow: function() {
      return this.item && this.item.content && this.item.content.length > 0;
    }
  },
  watch: {
    confirmed: function(value) {
      this.isConfirmed = value;
    }
  },
  created() {
    this.isConfirmed = this.confirmed;
  },
  methods: {
    close() {
      this.$parent.close();
    }
  }
};
</script>
